/*
 * This file is part of Universal Media Server, based on PS3 Media Server.
 *
 * This program is a free software; you can redistribute it and/or modify it
 * under the terms of the GNU General Public License as published by the Free
 * Software Foundation; version 2 of the License only.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU General Public License for more
 * details.
 *
 * You should have received a copy of the GNU General Public License along with
 * this program; if not, write to the Free Software Foundation, Inc., 51
 * Franklin Street, Fifth Floor, Boston, MA 02110-1301, USA.
 */
import UmsAppShell from './components/UmsApp/UmsAppShell'
import I18nContext from './contexts/i18n-context'
import PlayerContext from './contexts/player-context'
import SessionContext from './contexts/session-context'
import I18nProvider from './providers/i18n-provider'
import PlayerProvider from './providers/player-provider'
import SessionProvider from './providers/session-provider'

function UmsApp() {
  return (
    <I18nProvider>
      <I18nContext.Consumer>
        {i18n => (
          <SessionProvider i18n={i18n}>
            <SessionContext.Consumer>
              {session => (
                <PlayerProvider i18n={i18n} session={session}>
                  <PlayerContext.Consumer>
                    {player => (
                      <UmsAppShell i18n={i18n} session={session} player={player} />
                    )}
                  </PlayerContext.Consumer>
                </PlayerProvider>
              )}
            </SessionContext.Consumer>
          </SessionProvider>
        )}
      </I18nContext.Consumer>
    </I18nProvider>
  )
}

export default UmsApp
